<ng-content select="ap-sips-message,ap-callout"></ng-content>

<form #sipsForm id="sipsForm" method="post" target="sips_iframe">
  <input #data type="hidden" name="Data" />
  <input #version type="hidden" name="InterfaceVersion" />
  <input #encode type="hidden" name="Encode" />
  <input #seal type="hidden" name="Seal" />
</form>
<iframe name="sips_iframe" #iframe id="sips-iframe" scrolling="no" class="iframeSips" title="{{ 'SUPPORT.SIPS.TITLE' | translate}}"></iframe>